/**
 * @desc 公共工具
 */

const Util = {
	/**
	 * 跳转统一登录方法
	 * @param {object} address 不同环境的地址配置
	 */
	redirectToSSO(address) {
		window.location.replace(
			`${address.OOS_ADDRESS}/html/?appKey=${address.APP_KEY}&redirectUrl=${window.location.origin}`
		)
	},
	/**
	 * 获取url中携带的参数
	 */
	getUrlParams() {
		let urlParam = {}
		if (window.location.search) {
			window.location.search
				.substr(1)
				.split('&')
				.forEach((v) => {
					let param = v.split('=')
					urlParam[param[0]] = param[1]
				})
		}
		return urlParam
	},
	/**
 * 获取url中携带的参数
 */
	getUrlParamsBystr(str) {
		let urlParam = {}
		if (str.indexOf('?') > -1) {
			str.split('?')[1]
				.split('&')
				.forEach((v) => {
					let param = v.split('=')
					urlParam[param[0]] = param[1]
				})
		}
		return urlParam
	},
	/**
	 * 设置Cookie
	 * @param {string} name 设置的Cookie属性
	 * @param {string} val  设置的Cookie值
	 * @param {string} path 设置的Cookie的路径
	 * @param {number} date 设置的Cookie的过期时间(天数)
	 */
	setCookie(name, val, path, date) {
		const oDate = new Date()
		oDate.setDate(oDate.getDate() + (date || 30))
		const sDate = `;expires=${oDate}`
		const Path = `;path=${path || '/'}`
		document.cookie = `${name}=${val}${sDate}${Path}`
	},

	/**
	 * 获取Cookie
	 * @param   {string} name 需要获取的Cookie属性
	 * @returns {string} 获取到的Cookie值
	 */
	getCookie(name) {
		const sCookies = document.cookie
		const arr = sCookies.split('; ')

		for (let i = 0; i < arr.length; i++) {
			const arr2 = arr[i].split('=')
			if (arr2[0] === name) {
				return arr2[1]
			}
		}

		return ''
	},

	/**
	 * 删除Cookie
	 * @param {string} name 需要删除的Cookie
	 */
	delCookie(name) {
		this.setCookie(name, '', '', -1)
	},

	/**
	 * 获取Cookie的个数
	 * @returns {number} Cookie的个数
	 */
	cookieLength() {
		const sCookie = document.cookie
		const arr = sCookie.split('; ')
		if (!sCookie) {
			return 0
		}
		return arr.length
	},
	/* 判断一个时间 在不在某个时间段内 */
	_isDuringDate(day) {
		let date = day.replace(/-/g, '/')
		const curDate = new Date(date);
		const newTime = new Date();
		const beginDate = new Date(Util._dateFormatter(newTime) + " " + "00:00:00");
		const endDate = new Date(Util._dateFormatter(newTime) + " " + "23:59:59");
		if (curDate >= beginDate && curDate <= endDate) {
			return true;
		}
		return false;
	},
	_dateFormatter(date) {
		let timer = date;
		// if (typeof date === "string") {
		// 	timer = date.replace(/\//g, "-");
		// }
		const time = new Date(timer);
		const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
		const month =
			time.getMonth() + 1 < 10
				? "0" + (time.getMonth() + 1)
				: time.getMonth() + 1;
		const year = time.getFullYear();
		return year + "/" + month + "/" + day;
	},
	_isToDayFormatter(timer, isToday) {
		const time = new Date(timer.replace(/-/g, '/'));
		const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
		const month =
			time.getMonth() + 1 < 10
				? "0" + (time.getMonth() + 1)
				: time.getMonth() + 1;
		const year = time.getFullYear();
		const hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
		const minutes =
			time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
		if (isToday) {
			return hours + ":" + minutes;
		} else {
			const newYear = new Date().getFullYear()
			return (newYear !== year ? year + "/" : '') + month + "/" + day;
		}
	},
	_mekaName(name) {
		if (!name || name === '') {
			return 'geely'
		} else {
			const pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
			const evall = new RegExp("^[a-zA-Z]+$");
			const cval = /^[\u4e00-\u9fa5]+$/;
			let _name = name.split('')
			let _filter = _name.filter(item => !pattern.test(item))
			return _filter[0]
			/* 如果第一个字是中文的话 */
			// if (cval.test(_filter[0])) {
			// 	return _filter[0]
			// } else {
			// 	/* 如果前两个字段都是英文的话 */
			// 	if (evall.test(_filter[0])) {
			// 		/* 首字母大写 */
			// 		return _filter[0].toUpperCase() + _filter[1]
			// 	} else {
			// 		return evall.test(_filter[0]) ? _filter[0].toUpperCase() : _filter[0]
			// 	}
			// }
		}
	}

}

export default Util
